var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "hearingAidSales__top-product" }, [
    _c("div", { staticClass: "grid" }, [
      _c("div", { staticClass: "grid__col--6 mix__chart mix__chart--mfg" }, [
        _c("div", { staticClass: "hearingAidSales__mix--mfg chart" }, [
          _c(
            "div",
            { staticClass: "chart__wrapper" },
            [
              _c("h3", [_vm._v("TOP PRODUCTS")]),
              _vm._v(" "),
              _c("Products", {
                attrs: { products: _vm.top1, "index-offset": 1 }
              })
            ],
            1
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "grid__col--6 mix__chart mix__chart--mfg" }, [
        _c("div", { staticClass: "hearingAidSales__mix--mfg chart" }, [
          _c(
            "div",
            { staticClass: "chart__wrapper" },
            [
              _c("h3", [_vm._v(" ")]),
              _vm._v(" "),
              _c("Products", {
                attrs: { products: _vm.top2, "index-offset": 9 }
              })
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }